<section>
    <mat-form-field>
      <mat-label>Last Name (Optional)</mat-label>
      <input matInput [(ngModel)]="guest.lastName" name="lastName"/>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Rest of Name (Optional)</mat-label>
      <input matInput [(ngModel)]="guest.firstName" name="firstName" #firstName="ngModel"/>
    </mat-form-field>
    <!-- <div [hidden]="firstName.valid || firstName.pristine" class="alert alert-danger"> Name is required</div> -->

    <!-- <mat-form-field>
      <input matInput [(ngModel)]="guest.preferredName" name="preferredName" placeholder="Preferred Name"/>
    </mat-form-field> -->

    <mat-form-field>
      <mat-label>Birthdate</mat-label>
      <input matInput [matDatepicker]="dateSearch" [(ngModel)]="guest.birthdate" name="birthdate" required/>
      <mat-datepicker-toggle matSuffix [for]="dateSearch"></mat-datepicker-toggle>
      <mat-datepicker #dateSearch startView="multi-year" [startAt]="startDate" ></mat-datepicker>
    </mat-form-field>
  </section>